<script>
import CalendarMixins from '../../../shared/mixins/calendar-mixins';
import PricingRange from './PricingRangePopper';

export default {
    props: ['categories', 'rootCategory'],
    mixins: [CalendarMixins],
    components: {
        PricingRange,
    },
    data() {
        return {
            calendarConfig: {
                header: {
                    left: 'prev,next today title',
                },
                unselectCancel: '.popper, .popper *, .multiselect__single',
                listDayFormat: 'MMMM Do dddd',
            },
            showPopper: false,
            popEvent: null,
            modalEvent: false,
        };
    },
    computed: {
        dataUrl() {
            return '/api/price-modifiers';
        },
        eventPriceModifier() {
            return _.get(this.calendar, 'selectedPriceModifier', null);
        },
        eventBaseValue() {
            return _.get(this.calendar, 'selectedEvent.base_yield', null);
        },
        eventName() {
            return _.get(this.calendar, 'selectedScheduleDate.title');
        },
        modalDay() {
            return moment(this.calendar.selectedEvent.start).format('dddd');
        },
        modalDate() {
            return moment(this.calendar.selectedEvent.start).date();
        },
    },
    created() {
        Bus.$on('calendarCellClicked', this.calendarCellClicked);
        Bus.$on('priceModifierSaved', this.refetchEvents);
    },
    beforeDestroy() {
        Bus.$off('calendarCellClicked', this.calendarCellClicked);
        Bus.$off('priceModifierSaved', this.refetchEvents);
    },
    methods: {
        calendarUnselectionMade() {
            this.calendar.haveSelection = false;
            this.calendar.selectedStartDate = null;
            this.calendar.selectedEndDate = null;
            this.calendar.datePickers = {
                start: null,
                end: null,
            };
        },
        calendarCellClicked(payload) {
            this.showPopper = true;
            let start = payload.event.start;
            let end = payload.event.end ? payload.event.end : payload.event.start;
            this.calendar.obj.fullCalendar('select', start.stripTime(), end.stripTime());
        },
        onCalendarSelection() {
            let haveProducts = _.get(this.calendar, 'selectedEvent.products', []).length > 0;
            let showPopper = this.showPopper || !haveProducts;
            this.popEvent = false;
            this.modalEvent = false;
            this.$nextTick(function () {
                if (showPopper) {
                    this.popEvent = true;
                    this.showPopper = false;
                } else {
                    this.modalEvent = true;
                    $(this.$refs.modal).modal('show');
                }
            });
        },
    },
};
</script>
